/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { I18nService } from '@dm/core';
import { type Observable } from 'rxjs';

import { LunsConst } from '../../../../../../service/block-service/lun-group/luns.const';
import { InfigoService } from '../../../infigo.service';
import { SourceEnumService } from '../../../source-enum.service';
import { RefreshComponent } from '../../RefreshComponent';

@Component({
    selector: 'app-file-system-base-info',
    templateUrl: './file-system-base-info.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileSystemBaseInfoComponent extends RefreshComponent {
    @Input() item;
    baseInfo;
    detail: any = {};
    loading = true;
    capacityPercentData = 0;

    constructor(private infigoService: InfigoService,
        public str: LunsConst,
        public i18n: I18nService,
        public enumService: SourceEnumService,
        public changeDetectorRef: ChangeDetectorRef) {
        super();
        const I18N = i18n.get;
        const enumGet = enumService.get.bind(enumService, 'FILESYSTEM');
        this.baseInfo = [
            {
                title: I18N('common.healthStatus_column'),
                key: 'HEALTHSTATUS',
                enumMap: enumGet('HEALTHSTATUS'),
            },
            {
                title: I18N('common.runningStatus_column'),
                key: 'RUNNINGSTATUS',
                enumMap: enumGet('RUNNINGSTATUS'),
            },
            {
                title: I18N('system.ownStoragePool_label'),
                key: 'PARENTNAME',
            },
        ];
    }

    requestInfo(): Observable<any> {
        return this.infigoService.getFileSystem(this.item.actionParams);
    }

    handleRequest(value: any): void {
        this.loading = false;
        this.detail = value.data;
        this.capacityPercentData = this.infigoService.usageValue(this.detail);
        this.clearTimer();
        this.updateLoading = false;
        this.changeDetectorRef.detectChanges();
    }
}
